<template>
    <transition name="modal">
		<div class="modal-mask">
			<div class="modal-wrapper" @click="$emit('closeModal')">
				<div class="row">
					<div class="col-xs-0 col-sm-0 col-md-2 col-lg-2"></div>
					<div class="col-xs-12 col-sm-12 col-md-8 col-lg-8">
						<div class="modal-container" @click.stop>
							<div
								class="modal-header row"
								style="justify-content: flex-end;"
							>
								<!-- <div class="col-6">
                    <button type="button" class="btn btn-sm btn-outline-primary" @click="$emit('newUserBack')">< Back</button>
                  </div> -->
								<div class="col">
									<button
										type="button"
										class="close"
										@click="$emit('closeModal')"
									>
										<span aria-hidden="true">&times;</span>
									</button>
								</div>
							</div>

							<div class="modal-body" v-if="woProgress">
								<h2 class="title">Print Epoxy Gambar</h2>

								<div class="text-center mb-3">
									<button class="btn btn-primary btn-lg" @click="print">Print</button>
									<button class="btn btn-danger btn-lg ml-3" @click="$emit('closeModal')">Batal</button>
								</div>

								<div class="mt-3 mb-3">
									
									<div v-for="(key , index) in Object.keys(woProgress)">
										<!-- <div class="row mt-1">
											<div class="col-md-1 text-center">
												<i class="fa fa-times-circle fa-lg" style="color:red"></i>
											</div>
											<div class="col-md-8">
												<h5>{{key}}</h5>
                                                
											</div>
										</div> -->

                                        <h5>{{key}}</h5>
                                        <div class="row">
                                            <div class="col-md-4 mt-1" v-for="image in woProgress[key]">
                                                <!-- {{image}} -->
                                                <input type="checkbox" v-model="selected" :value="{
                                                    text : key,
                                                    url : image
                                                }"/>
                                                <img :src="env.baseImage + '/' + image"  class="w-100 mt-2" style="max-height:150px;"/>
                                            </div>
                                        </div>
									</div>
								</div>

								<div id="printEpoxy" class="border border-secondary p-10 rounded">
									<print-header></print-header>
									<hr>

									<h2 class="text-center mt-3">Gambar Epoxy</h2>


									<div class="row">
										<!-- <template v-for="(key , index) in selected">
											<div :key="key" class="row">
												<h5 class="col-12 pl-3" v-if="woProgress[key]">{{key}}</h5>
												<div  v-for="img in woProgress[key]" class="col-md-4 pl-3 pr-3 mt-2 mb-2">
													<img :src="env.baseImage + '/' +img" style="height:200px;width:auto;max-width:100%;" />
												</div>
											
											</div>
										</template> -->
                                        <div class="col-md-4 text-center mt-3" v-for="data in selected">
                                            <h6>{{data.text}}</h6>
                                            <img :src="env.baseImage + '/' + data.url" style="height:200px;width:auto;max-width:100%;"/>
                                        </div>
										
									</div>

								</div>
								
							</div>
						</div>
					</div>
				</div>
				<!-- <div class="col-xs-0 col-sm-0 col-md-1 col-lg-1"></div> -->
			</div>
		</div>
	</transition>
</template>

<script>
import env from '@/env'
import printHeader from '@/components/print/print_header.vue'
export default {
    components : {
        printHeader
    },
    data () {
        return {
            env,
            woProgress : null,
            selected : []
        }
    },
    mounted () {
        this.showPrintEpoxy()
    },
    props : ['work_order_code'],
    methods : {
        print() {
			this.$htmlToPaper('printEpoxy' , () => {
				console.log("Done")
                this.$emit('closeModal')
			})
		},
        async showPrintEpoxy (flag) {
			try {
				let resp = await this.$http.get(`/api/v1/workorder/steps/${this.work_order_code}`)
				let data = Object.assign([] , resp.data.data.filter(x => x.step.id == 6 && x.status != -1));
				data = data.filter(x => x.estimations.length > 0 && (x.estimations[0].type == 'R/C' || x.estimations[0].type == 'Special Repair'))
				// console.log(data)

				let woProgressList = {}

				for(var i = 0 ; i < data.length ; i++) {
					let curData = data[i]
					// if(curData.img)

					curData.name = `Epoxy #${curData.id} - ${curData.estimations[0].sparepart.sparepart_variants.name} ${curData.estimations[0].extension ? '- ' + curData.estimations[0].extension : ''}`
					woProgressList[curData.name] = curData.img ? curData.img : null
				}

				// console.log(woProgressList)

				this.woProgress = woProgressList
			}
			catch(e) {
				console.log(e)
				this.$store.dispatch('triggerAlert' , [false , e , 'Something Went Wrong.'])
			}
		}
    }
}
</script>